"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = void 0;
const isObject = (value) => typeof value === 'object' &&
    !Array.isArray(value) &&
    value !== null &&
    Object.keys(value).length > 0;
exports.isObject = isObject;
